import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=0d80d29a&scoped=true&"
import script from "./ContactPage.vue?vue&type=script&lang=js&"
export * from "./ContactPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=0d80d29a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80d29a",
  null
  
)

export default component.exports